// Mirrors the backend contract: xeroLedgerAccountCode must match this pattern
// and the date range must not exceed 36 months. We validate client-side for a
// faster/clearer error, but the backend remains the source of truth and its
// 400 message is surfaced verbatim when it rejects.
export const XERO_LEDGER_ACCOUNT_CODE_PATTERN = /^[A-Za-z0-9_-]{1,32}$/
export const MAX_RANGE_MONTHS = 36

export const GENERATE_ANALYSIS_REPORT_COPY = {
  triggerLabel: 'Generate analysis report',
  modal: {
    title: 'Generate analysis report',
    body: "We'll send a download link to your email. This may take a few minutes.",
    submitLabel: 'Generate',
    submittingLabel: 'Generating',
    cancelLabel: 'Cancel'
  },
  fields: {
    currency: {
      label: 'Currency',
      placeholder: 'Select a currency'
    },
    xeroLedgerAccountCode: {
      label: 'Xero ledger account code',
      placeholder: 'Select a ledger account'
    },
    dateRange: {
      label: 'Date range',
      placeholder: 'Select a date range'
    }
  },
  validation: {
    currencyRequired: 'Please select a currency',
    ledgerAccountRequired: 'Please select a Xero ledger account code',
    ledgerAccountInvalid:
      'Ledger account code must be 1–32 characters (letters, numbers, hyphens or underscores)',
    dateRangeRequired: 'Please select a date range',
    fromAfterTo: 'The start date must be on or before the end date',
    rangeTooLong: `The date range must not exceed ${MAX_RANGE_MONTHS} months`
  },
  notifications: {
    success:
      "We're generating your report. You'll receive an email when it's ready.",
    error: 'Failed to generate analysis report'
  },
  docs: {
    label: 'Learn more',
    href: 'https://docs.sequencehq.com/revenue-recognition/overview'
  },
  testIds: {
    trigger: 'revrec.detail.generateAnalysisReport',
    modal: 'revrec.modal.generateAnalysisReport',
    currency: 'revrec.analysisReport.currency',
    xeroLedgerAccountCode: 'revrec.analysisReport.xeroLedgerAccountCode',
    dateRange: 'revrec.analysisReport.dateRange'
  }
} as const
